import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAuctionDetails } from '../../../store/auction-detail/action';
import { fetchBidDetails, submitPlaceBid } from '../../../store/auctions/action';
import { setupToast } from '../../../store/toast/action';
import BidModal from './bid-modal';

const mapStateToProps = ({ user }) => ({
    user
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setupToastConnect: setupToast,
    submitPlaceBidConnect: submitPlaceBid,
    fetchBidDetailsConnect: fetchBidDetails,
    getAuctionDetailsConnect: getAuctionDetails
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BidModal);